import React from 'react';

import ContratanteCadastrar from './cadastrar';
import ContratanteEditar from './editar';
import RecebivelTipoContratante from './recebivel';
import LancamentoAvulso from './avulso';
import CancelaContratante from './cancelar';

/**
 * Renderiza todos os modais usados na tela de contratantes.
 */
export default function ModaisContratante({
                                            showModals,
                                            setShowModals,
                                            reload,
                                            rowCurrent,
                                            providerInfo,
                                            credorId,
                                            totalContracts,
                                            credorGrupoId,
                                          }) {
  const handleClose = (modalKey) => {
    setShowModals((prev) => ({ ...prev, [modalKey]: false }));
  };

  return (
    <>
      {showModals.create && (
        <ContratanteCadastrar
          close={() => handleClose('create')}
          reload={reload}
          itemInfo={providerInfo.personal.usuario_id}
        />
      )}

      {showModals.edit && (
        <ContratanteEditar
          close={() => handleClose('edit')}
          reload={reload}
          itemInfo={rowCurrent}
        />
      )}

      {showModals.recebivel && (
        <RecebivelTipoContratante
          close={() => handleClose('recebivel')}
          reload={reload}
          itemInfo={rowCurrent}
        />
      )}

      {showModals.lancamento && (
        <LancamentoAvulso
          close={() => handleClose('lancamento')}
          reload={reload}
          itemInfo={rowCurrent}
        />
      )}

      {showModals.cancela && (
        <CancelaContratante
          close={() => handleClose('cancela')}
          reload={reload}
          itemInfo={rowCurrent}
        />
      )}
    </>
  );
}
